import { NavLink as RouterNavLink, Link, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarFooter,
} from "@/components/ui/sidebar";
import { useAuth } from "@/hooks/use-auth";
import {
  LayoutDashboard,
  Users,
  FolderKanban,
  FileText,
  Bell,
  Settings,
  CreditCard,
  Globe,
  Server,
  Layout,
  BarChart3,
} from "lucide-react";


const memberMenuItems = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    title: "Clientes",
    url: "/dashboard/clientes",
    icon: Users,
  },
  {
    title: "Domínios",
    url: "/dashboard/dominios",
    icon: Globe,
  },
  {
    title: "Hospedagens",
    url: "/dashboard/hospedagens",
    icon: Server,
  },
  {
    title: "Sites",
    url: "/dashboard/sites",
    icon: Layout,
  },
  {
    title: "Projetos",
    url: "/dashboard/projects",
    icon: FolderKanban,
  },
  {
    title: "Contratos",
    url: "/dashboard/contracts",
    icon: FileText,
  },
  {
    title: "Notificações",
    url: "/dashboard/notifications",
    icon: Bell,
  },
  {
    title: "Uso & Limites",
    url: "/dashboard/usage",
    icon: BarChart3,
  },
];

const settingsItems = [
  {
    title: "Perfil",
    url: "/dashboard/profile",
    icon: Settings,
  },
  {
    title: "Assinatura",
    url: "/dashboard/subscription",
    icon: CreditCard,
  },
];

export function MemberSidebar() {
  const location = useLocation();
  useAuth();

  const isActive = (path: string) => {
    if (path === "/dashboard") {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Sidebar>
      <SidebarHeader className="border-b border-sidebar-border h-16 flex items-center justify-center">
        <div className="flex flex-col gap-2 px-2 items-center justify-center w-full">
          <Link to="/dashboard" className="flex items-center gap-2 justify-center">
            <img src="/devlovers-logo-light.png" alt="DevLovers" className="h-6 w-auto block dark:hidden" />
            <img src="/devlovers-logo-dark.png" alt="DevLovers" className="h-6 w-auto hidden dark:block" />
          </Link>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Menu Principal</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {memberMenuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild isActive={isActive(item.url)}>
                    <RouterNavLink to={item.url}>
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </RouterNavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        <SidebarGroup>
          <SidebarGroupLabel>Configurações</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {settingsItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild isActive={isActive(item.url)}>
                    <RouterNavLink to={item.url}>
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </RouterNavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="border-t border-sidebar-border p-4">
        <div className="text-xs text-muted-foreground text-center font-medium">
          Membro DevLovers ❤️
        </div>
      </SidebarFooter>
    </Sidebar>
  );
}
